import { render, staticRenderFns } from "./BlogMenu.vue?vue&type=template&id=5546490a&scoped=true"
import script from "./BlogMenu.vue?vue&type=script&lang=js"
export * from "./BlogMenu.vue?vue&type=script&lang=js"
import style0 from "./BlogMenu.vue?vue&type=style&index=0&id=5546490a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546490a",
  null
  
)

export default component.exports